import React, {useCallback, useEffect, useState} from 'react';
import './menuListComponent.scss';
import {IMenuItem} from "../../../models/menu.model";
import {NavLink, useLocation} from "react-router-dom";
import {CommonService} from "../../../services";
import ScienceIcon from '@mui/icons-material/Science';
import BusinessIcon from '@mui/icons-material/Business';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BallotIcon from '@mui/icons-material/Ballot';
import BarChartIcon from '@mui/icons-material/BarChart';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SummarizeIcon from '@mui/icons-material/Summarize';
import GroupsIcon from '@mui/icons-material/Groups';
import {Help, Outbox} from "@mui/icons-material";
import AccessControlComponent from "../../access-control/AccessControlComponent";
// import QrCode2Icon from '@mui/icons-material/QrCode2';
// import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
// import FolderZipIcon from '@mui/icons-material/FolderZip';
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import TooltipComponent from "../../tooltip/tooltipComponent";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import InventoryIcon from '@mui/icons-material/Inventory';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PopOversComponent from "../../pop-overs/PopOversComponent";
// import BiotechIcon from '@mui/icons-material/Biotech';
import PeopleIcon from '@mui/icons-material/People';

export interface MenuListComponentProps {
    sideMenuView: string;
}

const menuList: IMenuItem[] = [
    {
        path: CommonService._routeConfig.Dashboard(),
        title: 'Dashboard',
        code: 'dashboard',
        icon: <BarChartIcon/>
    },
    {
        path: CommonService._routeConfig.LabListRoute(),
        title: 'Lab',
        code: 'Lab',
        icon: <ScienceIcon/>
    },
    {
        path: CommonService._routeConfig.FacilityListRoute(),
        title: 'Facility',
        code: 'Facility',
        icon: <MapsHomeWorkIcon/>
    },
    {
        path: CommonService._routeConfig.LocationListRoute(),
        title: 'Location',
        code: 'Location',
        icon: <BusinessIcon/>
    },
    {
        path: CommonService._routeConfig.PatientListRoute(),
        title: 'Patient',
        code: 'Patient',
        icon: <GroupsIcon/>
    },
    {
        path: CommonService._routeConfig.TestOrderListRoute(),
        title: 'Test Order',
        code: 'TestOrder',
        icon: <AssignmentIcon/>
    },
    {
        path: CommonService._routeConfig.SamplesListRoute(),
        title: 'Sample',
        code: 'TestOrderSample',
        icon: <SummarizeIcon/>
    },
    {
        path: CommonService._routeConfig.AccessioningListRoute(),
        title: 'Accessioning',
        code: 'Accession isSpecificModuleToHide',
        icon: <ScienceIcon/>
    },
    // {
    //     path: CommonService._routeConfig.LabOsRoute(),
    //     title: 'Lab OS',
    //     code: '',
    //     icon: <BiotechIcon/>,
    //     children: [
    //         {
    //             path: CommonService._routeConfig.LabOsSampleProcessingRoute(),
    //             title: 'Sample Processing',
    //             code: 'SampleProcessing',
    //             icon: <ScienceIcon/>
    //         },
    //         // {
    //         //     path: CommonService._routeConfig.LabOsRoute(),
    //         //     title: 'R/Chemistry Workflow',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.LabOsRoute(),
    //         //     title: 'Endocrinology Workflow',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         {
    //             path: CommonService._routeConfig.QualityAssuranceRoute(),
    //             title: 'Quality Assurance',
    //             code: 'QualityAssurance',
    //             icon: <ScienceIcon/>
    //         },
    //         {
    //             path: CommonService._routeConfig.QualityControlRoute(),
    //             title: 'Quality Control',
    //             code: 'QualityControl',
    //             icon: <ScienceIcon/>
    //         },

    //         {
    //             path: CommonService._routeConfig.SopRoute(),
    //             title: 'SOPs and Validations',
    //             code: 'SOP&Validation',
    //             icon: <ScienceIcon/>
    //         },
    //         {
    //             path: CommonService._routeConfig.InstrumentRoute(),
    //             title: 'Instrument',
    //             code: 'Instruments',
    //             icon: <ScienceIcon/>
    //         },
    //         // {
    //         //     path: CommonService._routeConfig.InventoryManagementRoute(),
    //         //     title: 'Inventory Management',
    //         //     code: 'InventoryManagement',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.HrDocumentsRoute(),
    //         //     title: 'HR & Employee Documents',
    //         //     code: 'HR&EmployeeDocuments',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.formsRoute(),
    //         //     title: 'Forms',
    //         //     code: 'Forms',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.LabDepartmentsRoute(),
    //         //     title: 'Departments',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.LabEquipmentRoute(),
    //         //     title: 'Instrument/Equipment',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.LabStorageRoute(),
    //         //     title: 'Storage',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.LabPlatesRoute(),
    //         //     title: 'Plates',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         // {
    //         //     path: CommonService._routeConfig.LabCalculationsRoute(),
    //         //     title: 'Calculations',
    //         //     code: 'Lab',
    //         //     icon: <ScienceIcon/>
    //         // },
    //         {
    //             path: CommonService._routeConfig.LabReportsRoute(),
    //             title: 'Reports',
    //             code: 'Reports',
    //             icon: <ScienceIcon/>
    //         }
    //     ]
    // },
    {
        path: CommonService._routeConfig.TestListRoute(),
        title: 'Test',
        code: 'Test',
        icon: <BallotIcon/>
    },
    {
        path: CommonService._routeConfig.ResultListRoute(),
        title: 'Result',
        code: 'Result',
        icon: <AssignmentTurnedInIcon/>
    },
    {
        path: CommonService._routeConfig.SendoutSessionListRoute(),
        title: 'Sendout',
        code: 'SendOuts',
        icon: <Outbox/>
    },
    // {
    //     path: CommonService._routeConfig.QrCodeListRoute(),
    //     title: 'QR Code',
    //     code: 'QrCodes',
    //     icon: <QrCode2Icon/>
    // },
    // {
    //     path: CommonService._routeConfig.StateReportingListRoute(),
    //     title: 'State Reporting',
    //     code: 'StateReporting',
    //     icon: <ScheduleSendIcon/>
    // },
    // {
    //     path: CommonService._routeConfig.BarcodesListRoute(),
    //     title: 'Barcode',
    //     code: 'Barcode',
    //     icon: <FolderZipIcon/>
    // },
    {
        path: CommonService._routeConfig.SystemSettingsRoute(),
        title: 'System Settings',
        code: 'SystemSettings isSpecificModuleToHide',
        icon: <SettingsApplicationsIcon/>
    },
    {
        path: CommonService._routeConfig.UserListRoute(),
        title: 'User',
        code: 'User',
        icon: <PeopleIcon/>
    },
    {
        path: CommonService._routeConfig.AccessLevelListRoute(),
        title: 'Access Level',
        code: 'AccessControl isSpecificModuleToHide',
        icon: <LockPersonIcon/>
    },
    {
        path: CommonService._routeConfig.InventoryListRoute(),
        title: 'Inventory',
        code: 'inventory',
        icon: <InventoryIcon/>
    },
    {
        path: CommonService._routeConfig.BiomarkerListRoute(),
        title: 'Biomarkers',
        code: 'Biomarker',
        icon: <WorkspacesIcon/>
    },
    {
        path: CommonService._routeConfig.OCRBillingListRoute(),
        title: 'OCR Billing',
        code: 'ocrBilling',
        icon: <RequestQuoteIcon/>
    },
    {
        path:CommonService._routeConfig.SupportCenterRoute(),
        title: 'Support Center',
        code: 'dashboard',
        icon: <Help/>
    }
]

const labOsSubMenu = menuList.find((menu) => menu.title === "Lab OS");


const MenuListComponent = (props: MenuListComponentProps) => {
    const {sideMenuView} = props;

    const location = useLocation();

    const {currentNavParams} = useSelector((state: IRootReducerState) => state.header);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [anchorEl, setAnchorEl] = useState<any>(null);
    const [isOpendedPopOver, setIsOpenedPopOver] = useState(false);
    const containerRef = React.useRef<HTMLDivElement>(null);


    useEffect(() => {
        if (!containerRef.current) return;
        const activeElement = containerRef.current.querySelector('.menu-item.active');
        if (activeElement) {
            activeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }, []);

    const [isLabOsActive, setIsLabOsActive] = React.useState<boolean>(false);
    const [isLabOsExpanded, setIsLabOsExpanded] = React.useState<boolean>(false);

    useEffect(() => {
        const activeMenuList = location.pathname.split('/').filter((item) => item !== '');
        if (activeMenuList?.length > 0 && activeMenuList[0] === 'lab-os') {
            setIsLabOsActive(true);
            setIsLabOsExpanded(true);
        } else {
            setIsLabOsActive(false);
            setIsLabOsExpanded(false);
        }
    }, [location.pathname, currentUser]);

    const toggleLabOSExpanded = () => {
        setIsLabOsExpanded((oldState) => !oldState);
    }

    const subMenuRenderer = useCallback((menu: IMenuItem) => {
        return <div className="sub-menu-item-children">
            {
                menu?.children?.map((child, index) => {
                    return (
                        <AccessControlComponent
                            key={child.title}
                            moduleCode={child.code}
                        >
                            <NavLink to={child.path}
                                     className={(state) => {
                                         if (state.isActive) {
                                             return "sub-menu-item active";
                                         }
                                         return "sub-menu-item";
                                     }}
                                     id={`${child.title.toLowerCase()}_menu`}>
                                <div className={`sub-menu-item-wrapper`}>
                                                                  <span
                                                                      className="sub-menu-item-title">{child.title}</span>
                                </div>
                            </NavLink>
                        </AccessControlComponent>
                    )
                })
            }
        </div>
    }, [])

    return (
        <>
            <PopOversComponent
                isOpen={isOpendedPopOver && sideMenuView === 'compact'}
                className={"menu-list-popover"}
                anchorEl={anchorEl}
                onClose={() => {
                    setIsOpenedPopOver(false);
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                {labOsSubMenu && subMenuRenderer(labOsSubMenu)}
            </PopOversComponent>
            <div className='menu-list' ref={containerRef}>
                {
                    menuList.map((menu, index) => {
                        return (
                            <AccessControlComponent
                                key={menu.title}
                                moduleCode={menu.code}
                                subMenuItems={menu?.children}
                            >
                                <>
                                    <NavLink to={menu.path}
                                             // onClick={(e) => {
                                             //     if (menu?.children && menu?.children?.length>0) {
                                             //         e.preventDefault();
                                             //         setIsLabOsActive(true)
                                             //         setIsLabOsExpanded((prev) => !prev)
                                             //     }
                                             // }}
                                             className={(state) => {
                                                 if (state.isActive || currentNavParams?.meta === menu.title) {
                                                     return "menu-item active";
                                                 }
                                                 return "menu-item";
                                             }}
                                             id={`${menu.title.toLowerCase()}_menu`}>
                                        <div className={`menu-item-wrapper`}>
                                            {sideMenuView === 'compact' ?
                                                <TooltipComponent tooltip={menu.title} key={index} arrow={true}>
                                        <span
                                            onClick={() => {
                                                if (menu && menu.children && menu.children.length > 0 && menu.title) {
                                                    setIsOpenedPopOver(true);
                                                    setAnchorEl(document.getElementById(`${menu.title.toLowerCase()}_menu`));
                                                }
                                            }}
                                            className={`menu-item-icon  default-side-icon`}>{menu.icon}</span>
                                                </TooltipComponent> :
                                                <span
                                                    className={`menu-item-icon ${sideMenuView === 'default' ? "default-side-icon" : ""}`}>{menu.icon}</span>
                                            }
                                            {sideMenuView === 'default' &&
                                                <span className={'menu-item-lab-os-wrapper'}>
                                                <span className="menu-item-title">{menu.title}</span>
                                                    {menu.title === 'Lab OS' && isLabOsActive &&
                                                        <span className="menu-icon"
                                                              onClick={toggleLabOSExpanded}>{!isLabOsExpanded ?
                                                            <KeyboardArrowDownIcon/> : <KeyboardArrowUpIcon/>}</span>}
                                            </span>
                                            }
                                        </div>
                                    </NavLink>
                                    {
                                        isLabOsActive && isLabOsExpanded && menu.children && menu.children.length > 0 && sideMenuView === 'default' &&
                                        subMenuRenderer(menu)
                                    }
                                </>
                            </AccessControlComponent>
                        )
                    })
                }
            </div>
        </>
    )

};

export default MenuListComponent;
